/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "IdPair": {
            "fields": {
              "serverId": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "clientId": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.IdPair) {
  $root.addJSON(jsonData);
}

/**
 * A client-server id pair to represent an object.
 *
 * Once the client has a server_id, both values MUST be sent.
 *
 * Legacy objects may contain only a server_id.
 *
 * Once a resource is created, such as a Bill, the client should
 * echo the full identifier without modification.  The server will
 * return a properly formed Identifier including the client_id.
 *
 * SOURCE IdPair @ squareup/client/id_pair.proto at 24:1
 */
export const IdPair = $root.lookupType('squareup.client.IdPair');
fixType(IdPair);
Builder.createAndAttachToType(IdPair);